// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import CabinBaggagePostbooking from '../components/CabinBaggagePostbooking';
import CabinBaggagePrimaryFlow from './CabinBaggagePrimaryFlowContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const CabinBaggageContainer = ({
  bundleData,
  form,
  includedBaggage,
  isBaggageAvailableOrIncluded,
  isPostBooking,
  order,
  readMore,
  productPosition,
  shouldUseCarrierSpecificUnavailableLabel,
  travelerNumber
}) => {
  if (isPostBooking) {
    return /*#__PURE__*/_jsx(CabinBaggagePostbooking, {
      order: order
    });
  }
  return /*#__PURE__*/_jsx(CabinBaggagePrimaryFlow, {
    bundleData: bundleData,
    form: form,
    includedBaggage: includedBaggage,
    isBaggageAvailableOrIncluded: isBaggageAvailableOrIncluded,
    order: order,
    productPosition: productPosition,
    readMore: readMore,
    shouldUseCarrierSpecificUnavailableLabel: shouldUseCarrierSpecificUnavailableLabel,
    travelerNumber: travelerNumber
  });
};
export default CabinBaggageContainer;
//# sourceMappingURL=CabinBaggageContainer.js.map